import { AfterViewInit, Directive, ElementRef, Input, OnDestroy } from '@angular/core';

@Directive({
    // tslint:disable-next-line: directive-selector
    selector: '[autofocus]',
    standalone: false,
})
export class AutofocusDirective implements AfterViewInit, OnDestroy {
    @Input() set autofocus(condition: boolean) {
        this.focus = condition !== false;
    }

    private focus = false;
    private timeoutId: any;

    constructor(private el: ElementRef) {}

    setFocus = () => {
        // Only attempt to focus when explicitly enabled
        if (!this.focus) {
            return;
        }

        // Try to focus the input element (or the host itself if it's an input)
        const element: HTMLInputElement = this.el.nativeElement?.querySelector('input') || this.el.nativeElement;
        if (element) {
            this.timeoutId = setTimeout(() => {
                element?.focus();
            }, 0);
        }
    };

    ngAfterViewInit() {
        this.setFocus();
    }

    ngOnDestroy(): void {
        if (this.timeoutId) {
            clearTimeout(this.timeoutId);
        }
    }
}
